import { render } from "./FinishPrintCard.vue?vue&type=template&id=2bb13117"
import script from "./FinishPrintCard.vue?vue&type=script&lang=js"
export * from "./FinishPrintCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__